import Vue from 'vue';
import Router from 'vue-router';
import Routes from './routes';
import state from '../state/index';
import axios from 'axios';
import API from '../API';
import { checkUserDocumentsTotalStorage } from './../utils/documents';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: Routes
});

/**
 * Performs an authentication validation on each route.
 * @param {Object} to
 * @param {Object} from
 * @param {Function} next
 */
const auth = async function(to, from, next) {
  let jwt = state.getters['auth/getJWT'];
  let user = state.getters['auth/getUser'];
  let needsCheckout = state.getters['auth/getNeedsCheckout'];
  const previousURL = state.getters['auth/getPreviousURL'];
  // if (jwt && user) {
  if (!jwt) {
    try {
      let response = await axios.get(API.me);
      user = response.data;
      jwt = response.headers.auth;
      if (jwt && user) {
        user.token = jwt;
        state.commit('auth/setUser', user);
      }
    } catch (ex) {
      console.log('Failed to get the current user: ', ex);
    }
  }
  // Check if there is a user
  if (jwt && user) {
    const storageUsage = state.getters['documents/getDocumentsTotalStorage'];
    // // Check if they need to pay.
    // if (user.account.delinquent) {
    //   // If we are not on the delinquent page, we need to send the user there.
    //   if (!to.meta.delinquent) {
    //     return next({
    //       path: '/profile/payment',
    //       query: {
    //         from: to.fullPath,
    //         delinquent: true
    //       }
    //     });
    //   }
    // }
    if (jwt && user && !user.account.delinquent && !storageUsage) {
      axios.defaults.headers.common['auth'] = jwt;
      await checkUserDocumentsTotalStorage();
    }
  }
  if (needsCheckout && to.name !== 'profileTab' && to.params.tab !== 'checkout' && to.name !== 'subscriptionConfirmation' ){
    next({
      path: previousURL
    });
  } else {
    next();
  }
  // If an enterprise user tries to go to the upgrade path,
  // redirect them to the enpterprise upgrade view.
  if (
    to.path === '/upgrade' &&
    user.account.subscription.plan.type === 'enterprise'
  ) {
    next({
      path: '/upgrade-enterprise'
    });
  }
  // Other route rules
  if (
    to.path === '/reports' &&
    user.account.subscription.plan.features.reports.value !== true
  ) {
    next({
      path: '/upgrade'
    });
  } else if (
    to.path === '/integrations' &&
    user.account.subscription.plan.features.zapier.value !== true
  ) {
    next({
      path: '/upgrade'
    });
  } else if (
    to.path === '/profile/team' &&
    parseInt(user.account.subscription.plan.features.users.value, 10) === 1
  ) {
    next({
      path: '/upgrade-enterprise'
    });
  }
  // General Auth rules
  if (to.meta.auth === true && !jwt) {
    next({
      path: '/',
      query: {
        from: to.fullPath
      }
    });
  } else if (to.meta.auth === false && jwt) {
    // Set the default auth header if it isn't there.
    axios.defaults.headers.common['auth'] = jwt;
    next({
      path: '/dashboard'
    });
  } else {
    // Set the default auth header if it isn't there.
    axios.defaults.headers.common['auth'] = jwt;
    next();
  }
};

/**
 * Configure an authentication check for each path.
 */
router.beforeEach(auth);

export default router;
